var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(_vm.chip)?_c('v-chip',{staticClass:"ma-2",attrs:{"close":"","color":"orange","small":""},on:{"click:close":_vm.removeReminder,"click":_vm.sendAlimTalk}},[_vm._v(" "+_vm._s(_vm.localText)+" ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }